export default __webpack_public_path__ + "static/media/close.98783fa4.svg";